import angular from 'angular';
import scenes from './scenes';
import components from './components';

export default angular.module('scenes.helloBook', [scenes, components]).name;
